import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { AxiosResponse } from "axios";

export const getUserProfileStatus = (userId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERPROFILESTATUS}`,
    {
      params: {
        Id: userId,
      },
    }
  );
};

export const getTeachersByStateId = (stateId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_TEACHERS_GETBYSTATEID}`,
    {
      params: {
        StateId: stateId,
      },
    }
  );
};

export const getRequest = (
  serviceName: string,
  requestObj: string,
  userId?: number,
  action?: string
): Promise<AxiosResponse<string>> => {
  return AxiosHelper.axiosInstance().post<string>(APIConstant.GET_REQUEST, {
    serviceName: serviceName,
    requestPacket: requestObj,
    userId: userId ?? null,
    action: action ?? null,
  });
};

export const getRequestPublic = (
  questionGuid: string,
  languageId: number,
  requestPacket: string
): Promise<AxiosResponse<string>> => {
  return AxiosHelper.axiosInstance().post<string>(
    APIConstant.GET_REQUEST_PUBLIC,
    {
      questionGuid: questionGuid,
      requestPacket: requestPacket,
      languageId: languageId,
    }
  );
};

export const createLoginLink = (userId: number, createdByUserId: number) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_CREATELOGINLINK}`,
    {
      userId: userId,
      createdByUserId: createdByUserId,
    }
  );
};
